import _identity from "ramda/src/identity";
import _pathOr from "ramda/src/pathOr";
import _path from "ramda/src/path";
import _prop from "ramda/src/prop";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _mergeRight from "ramda/src/mergeRight";
import _fromPairs from "ramda/src/fromPairs";
import _toLower from "ramda/src/toLower";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _pipe from "ramda/src/pipe";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import contentType from 'content-type';
import { isObject } from "../../browser/is";
import { toArray, map } from "../../browser/iterable";
import { pipe as pipeAsync } from "../../browser/async";
import { statusCodeName } from "../../browser/http";
var parseContentType = contentType.parse;
var assign = Object.assign;
var FetchError = function FetchError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$message = _ref.message,
    message = _ref$message === void 0 ? 'Server Error' : _ref$message,
    _ref$status = _ref.status,
    status = _ref$status === void 0 ? 500 : _ref$status,
    errors = _ref.errors,
    _ref$code = _ref.code,
    code = _ref$code === void 0 ? statusCodeName(status) : _ref$code,
    stack = _ref.stack,
    traceId = _ref.traceId;
  var err = Error(message);
  if (stack) err.stack = stack;
  if (traceId) err.traceId = traceId;
  if (errors) err.errors = errors;
  return assign(err, {
    code: code,
    status: status,
    statusCode: status
  });
};
export var serializeBody = function serializeBody(contentType, body) {
  var _parseContentType = parseContentType(contentType),
    type = _parseContentType.type;
  if (type === 'application/json') return JSON.stringify(body);
  return body;
};
export var headersToObject = _pipe(map(function (_ref2) {
  var _ref3 = _slicedToArray(_ref2, 2),
    key = _ref3[0],
    val = _ref3[1];
  return [_toLower(key), val];
}), toArray, _fromPairs);
export var normalize = function normalize(fetch) {
  return function (url) {
    var config = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (isObject(url)) {
      var _ref4 = [url, url];
      config = _ref4[0];
      url = _ref4[1].url;
    }
    return fetch(_mergeRight({
      headers: {},
      url: url
    }, config));
  };
};
export var parseResponse = function () {
  var _ref5 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(res) {
    var status, headers, _parseContentType2, type, body;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          status = res.status;
          headers = headersToObject(res.headers);
          _parseContentType2 = parseContentType(headers['content-type'] || 'text/plain'), type = _parseContentType2.type;
          body = res;
          if (!(type === 'application/json')) {
            _context.next = 8;
            break;
          }
          _context.next = 7;
          return res.json();
        case 7:
          body = _context.sent;
        case 8:
          if (!(type === 'text/plain')) {
            _context.next = 12;
            break;
          }
          _context.next = 11;
          return res.text();
        case 11:
          body = _context.sent;
        case 12:
          return _context.abrupt("return", {
            body: body,
            headers: headers,
            status: status,
            statusCode: status
          });
        case 13:
        case "end":
          return _context.stop();
      }
    }, _callee);
  }));
  return function parseResponse(_x) {
    return _ref5.apply(this, arguments);
  };
}();
export var handleError = function () {
  var _ref6 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee2(res) {
    var _parseContentType3, type, traceId, status, statusText;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) switch (_context2.prev = _context2.next) {
        case 0:
          _parseContentType3 = parseContentType(res.headers.get('content-type') || 'text/plain'), type = _parseContentType3.type;
          traceId = res.headers.get('x-amzn-trace-id') || res.headers.get('x-b3-traceid');
          status = res.status, statusText = res.statusText;
          if (!(type === 'application/json')) {
            _context2.next = 5;
            break;
          }
          return _context2.abrupt("return", res.json().then(function (_ref7) {
            var bodyMessage = _ref7.message,
              bodyCode = _ref7.code,
              bodyStack = _ref7.stack,
              _ref7$errors = _ref7.errors,
              errors = _ref7$errors === void 0 ? [] : _ref7$errors;
            var firstErr = _prop(0, errors);
            throw FetchError({
              status: status,
              traceId: traceId,
              errors: errors,
              code: bodyCode || _prop('code', firstErr) || _path(['extensions', 'code'], firstErr) || statusText,
              message: bodyMessage || _prop('message', firstErr) || statusText,
              stack: bodyStack || _pathOr([], ['extensions', 'exception', 'stacktrace'], firstErr).join('\n')
            });
          }));
        case 5:
          return _context2.abrupt("return", res.text().then(function (message) {
            throw FetchError({
              message: message,
              status: status,
              code: statusText,
              traceId: traceId
            });
          }));
        case 6:
        case "end":
          return _context2.stop();
      }
    }, _callee2);
  }));
  return function handleError(_x2) {
    return _ref6.apply(this, arguments);
  };
}();
export var RESPONSE = {
  RAW: _identity,
  BODY: pipeAsync(parseResponse, _prop('body')),
  FULL: parseResponse
};